import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { RiAccountCircleFill } from "react-icons/ri";
import AppContext from "../../context/AppContext";
import translations from "../common/Translations";
import CommonButton from "../common/CommonButton";
import { hasScreenAccess } from "../../utils/permissions";

const UserToolbar = () => {
  const navigate = useNavigate();
  const { theme, langMode } = useContext(AppContext);

  const handleNavigate = () => {
    navigate("/add-user");
  };

  return (
    <div
      className={`flex flex-wrap justify-end items-center gap-3 bg-white ${theme === "dark" ? "dark-mode" : theme === "high-contrast" ? "high-contrast" : ""
        }`}
    >
      {hasScreenAccess("USER_MANAGEMENT", "canCreate") && (
        <CommonButton
          onClick={handleNavigate}
          variant="primary"
          tooltipPosition="left"
          tooltipText={translations[langMode].addauserassingroles}
          data-testid="add-user"
        >
          <RiAccountCircleFill className="w-5 h-5 mr-1" title="add user" />
          <span className="hidden sm:inline">
            {translations[langMode].addUser}
          </span>
        </CommonButton>
      )}
    </div>
  );
};

export default UserToolbar;
